import { useEffect, useRef } from 'react'
import { Animated, StyleSheet, View } from 'react-native'
import { type Notice, useNoticeStore } from '@/stores/notice-store'
import { NoticeItem } from '@/ui/NoticeItem'

const ENTRY_DURATION = 200

function AnimatedToast({ notice, onDismiss }: { notice: Notice; onDismiss: () => void }) {
    const opacity = useRef(new Animated.Value(0)).current
    const translateX = useRef(new Animated.Value(16)).current

    useEffect(() => {
        Animated.parallel([
            Animated.timing(opacity, {
                toValue: 1,
                duration: ENTRY_DURATION,
                useNativeDriver: true,
            }),
            Animated.timing(translateX, {
                toValue: 0,
                duration: ENTRY_DURATION,
                useNativeDriver: true,
            }),
        ]).start()
    }, [opacity, translateX])

    return (
        <Animated.View style={{ opacity, transform: [{ translateX }] }}>
            <NoticeItem
                notice={notice}
                variant="toast"
                onDismiss={onDismiss}
                showCloseButton={notice.dismissible !== false}
            />
        </Animated.View>
    )
}

export function NoticeToastList() {
    const notices = useNoticeStore(s => s.notices)
    const dismiss = useNoticeStore(s => s.dismiss)

    if (notices.length === 0) return null

    return (
        <View
            style={styles.container}
            pointerEvents="box-none"
            accessibilityLiveRegion="polite"
            role="status"
        >
            {notices.map(n => (
                <AnimatedToast key={n.id} notice={n} onDismiss={() => dismiss(n.id)} />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        top: 16,
        right: 16,
        gap: 8,
        zIndex: 9999,
    },
})
